// src/services/location.service.js

const CSC_BASE_URL = "https://api-csc.indraq.info";

export const locationService = {
  async searchCities({ countryName = "India", stateName = "" }) {
    const url = `${CSC_BASE_URL}/api/cities?country_name=${encodeURIComponent(
      countryName
    )}&state_name=${encodeURIComponent(stateName)}`;

    const res = await fetch(url);
    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.message || "Failed to fetch cities");
    }

    return Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
  },

  async getPincodeDetails({ pincode, country = "IN" }) {
    const url = `https://pincode.indraq.info/api/v1/postal/${encodeURIComponent(
      pincode
    )}?country=${encodeURIComponent(country)}`;

    const res = await fetch(url);
    const data = await res.json();

    if (!res.ok || !data?.ok) {
      throw new Error(data?.message || "Invalid pincode");
    }

    return Array.isArray(data?.data) ? data.data : [];
  },
};